import { FC, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { checkPaymentStatus } from 'services/payment';
import withErrorBoundary from './withErrorBoundary';

const BookRevolutPage: FC = () => {
  const [urlParams] = useSearchParams();
  const navigate = useNavigate();

  const timeout = useRef<any>();
  const [triesCount, setTriesCount] = useState(60);

  useEffect(() => {
    const id = urlParams.get('id') || '';

    if (!id) return;
    setTimeout(() => {
      check(urlParams.get('id') || '');
    }, 10000);

    return () => {
      clearTimeout(timeout.current);
    };
  }, []); // eslint-disable-line

  const check = async (id: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(id);

    if (responseCheck?.bookingModel?.statusGoToXX) {
      sessionStorage.removeItem('bookPaymentHotels');
      sessionStorage.setItem(
        'bookStatusXX',
        JSON.stringify({
          orderId: responseCheck.bookingModel.orderId,
          transactionId: id,
        })
      );

      navigate('/status-xx');
    } else if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.removeItem('bookPaymentHotels');
      sessionStorage.setItem(
        'bookSuccessHotels',
        JSON.stringify({
          book: responseCheck.bookingModel,
          paxes: responseCheck.bookingModel.paxes,
          orderId: responseCheck.bookingModel.orderId,
          transactionId: id,
          couponAmount: responseCheck.bookingModel.couponAmount,
        })
      );

      navigate('/hotel/success');
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);
      sessionStorage.setItem(
        'bookFail',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId: id,
        })
      );
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(id), 5000);
    }
  };

  return (
    <div className="position-relative flex-one">
      <div className="ploader-backdrop">
        <div className="ploader-content">
          <FontAwesomeIcon icon={faCircleNotch} className="ploader-icon" />
          <div className="ploader-text">Please wait</div>
          <div className="ploader-text">while we process your payment</div>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(BookRevolutPage, 'BookRevolutPage');
